import React, { useEffect, useState } from "react";
import { BookingCard, CarPlateCard, InputField } from "../../components";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import cardData from "../../data/ProductData.json";
import { useLazyGetUserSellPostQuery } from "../../service/posts";
import { ListedPost } from "../../types/General";
import { getFromStorage, Loader, STORAGE_KEYS } from "../../helpers";
import useTranslation from "../../hooks/Translation";

const MyListedPost = () => {
  const translation = useTranslation();
  const language = getFromStorage(STORAGE_KEYS.language);

  const [listedPost, { isLoading }] = useLazyGetUserSellPostQuery();
  const [allListedPost, setAllLitedPost] = useState<ListedPost[]>([]);
  const [favItems, setFavItems] = useState<any[]>([]);
  const [likeItems, setLikeItems] = useState<any[]>([]);

  const getUserListedPost = async () => {
    try {
      const response = await listedPost({}).unwrap();

      if (response?.statusCode === 200) {
        setAllLitedPost(response?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserListedPost();
  }, []);

  return (
    <div className="main">
      <Loader isLoad={isLoading} />
      <div className={allListedPost?.length ? "crds_sec" : "crds_sec_noData"}>
        {allListedPost?.length ? (
          allListedPost?.map((item) => (
            <CarPlateCard
              posts
              role={item?.role}
              category={
                language === "en"
                  ? item?.categoryData?.categoryName || ""
                  : item?.categoryData?.categoryName_ar || ""
              }
              posttitle={item?.posttitle}
              price={item?.price}
              carPlatenumber={item?.carPlatenumber}
              _id={item?._id}
              setFavItems={setFavItems}
              favItems={favItems}
              item={item}
              likeItems={likeItems}
              setLikeItems={setLikeItems}
            />
          ))
        ) : (
          <div className="noData">
            <figure>
              <img src="/static/images/noData.webp" alt="" />
            </figure>
            <h3>{translation.error.noData}</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyListedPost;
